<template>
    <div class="mktops-maincontent-create maincontent-create-2">
        <div :class="(loadData == true) ? 'bg-backdrop-promotion-loading' : ''"></div>
        <div style="position: absolute;top: 50%; left: 50%; width: 10%; z-index: 20;" v-show="loadData == true">
            <md-progress-spinner :md-stroke="8" :md-diameter="65" md-mode="indeterminate"></md-progress-spinner>
        </div>

        <div class="mktops-mainheader-text md-layout-item md-size-100" >
            <label class="tab-title">create a promotion</label>
        </div>
        <div class="md-gutter mktops-stepper">
            <md-card class="main-content">
                <div class="header-step">
                    <md-avatar class="md-avatar-icon step-content-num">2</md-avatar>
                    <span class="card-title">Select Products</span>
                </div>
                <div class="data-input-step md-layout">
                    <div class="md-layout md-layout-item md-size-100">
                        <div class="md-layout-item md-size-100">
                                <div class="content-step-data md-layout md-gutter md-layout-item md-size-100" style="padding-left: 20px;">
                                    <div class="mktops-display md-layout-item md-size-100">
                                        <!-- <md-button class="mktops-button md-raised md-primary" @click="showDialog = true">
                                            <md-icon>search</md-icon>
                                            browse
                                        </md-button> -->
                                        <div class="md-layout-item md-size-20"> 
                                            <md-button title="Export Template File for upload" class="mktops-button md-raised md-button-upload" style="color: #FFF !important;background-color: #A8A8A8 !important; width:134px !important;height: 60px !important;" @click="export_format">
                                                    <md-icon style="color: #FFF !important;" >file_download</md-icon>
                                                    export
                                            </md-button>
                                        </div>
                                        <div class="md-layout-item md-size-20"> 
                                            <md-button title="Browse File for up load data to system" class="mktops-button md-raised md-button-upload" style="color: #FFF !important;background-color: #3F51B5 !important; width:134px !important;height: 60px !important; margin-left: -5px;" @click="trigger">
                                                <md-icon style="color: #FFF !important;" >file_upload</md-icon>
                                                upload
                                            </md-button> 
                                        </div>
                                        <div class="md-layout-item md-size-60" style="display: flex; background-color: #F7F7F7;padding-left: 10px;border-radius: 4px;margin-left: -18px">
                                            <div class="mktops-control-box" style="width: 80%;padding-top: 13px">
                                                <treeselect ref="productTxt" class="treeview-box" :multiple="true" :limit="1" :maxHeight="400" placeholder="+ Add with Product Code" :async="true" :load-options="loadOptions" :cache-options="false" v-model="valueTree" :value-consists-of="valueConsistsOf" :clearable="false" @select="openOnSelectTreeview" @deselect="onDeSelectTreeview" @open="onOpenTreeview" 
                                                />
                                            </div>
                                            <i class="material-icons" title="Search All Product" style="margin-top: 20px; margin-left: 15px; cursor: pointer;" @click="onClickDialogFilter()">filter_list</i>
                                        </div>
                                        <input type="file" ref="fileInput" class="mktops-browse-file" @change="processFile"/>
                                        
                                        <!-- <div class="mktops-product mktops-display md-layout-item">
                                            <md-field md-inline :class="messageClass">
                                                <label class="mktops-product-label">Product Code (if multiple, seperate by space)</label>
                                                <md-input v-model="product_code" @keyup.enter.native="addProducts"></md-input>
                                            </md-field>
                                            <md-button @click="addProducts()" class="mktops-button-add-clear md-primary">add</md-button>
                                            <md-button @click="clearProducts()" class="mktops-button-add-clear">clear</md-button>
                                        </div> -->
                                    </div>
                                    
                                </div>
                                <div class="md-layout md-gutter md-layout-item md-size-100" v-if="products.length === 0" style="margin-top: calc(50vh - 160px);">
                                    <div class="md-layout-item md-size-20"></div>
                                    <div class="md-layout-item md-size-60" style="text-align: center;">
                                        <span style="font-size: 16px;color:#A8A8A8;">Select products by uploading a .csv, or adding by product code</span>
                                    </div>
                                    <div class="md-layout-item md-size-20"></div>
                                </div>
                                <div class="md-layout md-gutter md-layout-item md-size-100">
                                    <!-- ## -->
                                    <div class="md-layout md-gutter md-layout-item md-size-100" v-if="products.length > 0">
                                        <div class="md-layout-item md-size-50" >
                                            <h1 class="card-title" style="font-size: 14px;">Selected Products for delete</h1>
                                        </div>
                                        <div class="md-layout-item md-size-40" style="padding-right: 0px;">
                                            <!-- <md-field md-clearable >
                                                <md-icon>search</md-icon><md-input placeholder="Search product code for delete" v-model="search" @input="searchOnTable" />
                                            </md-field> -->
                                        </div>
                                         <div class="md-layout-item md-size-10" style="padding-top: 20px;padding-left: 0px;">
                                            <md-button class="md-icon-button md-primary"  @click="deleteProduct"> 
                                                <md-icon  class="md-icon material-icons -delete-back" v-bind:style="checkedProducts.length === 0 ? {color: '#A8A8A8'} : {color: '#3F51B5'}"  title="Delete">delete_sweep</md-icon>
                                            </md-button>
                                         </div>
                                    </div>
                                    <div id="ff" class="md-layout md-gutter md-layout-item md-size-100" v-if="products.length > 0">
                                        <div class="md-layout-item md-size-100" >
                                            <div id="table-update-scroll-step2">
                                                <div id="divHeadUpdate">
                                                    <div style="width: 4%;">
                                                        <label class="checkbox-container" >
                                                        <input type="checkbox" @click="selectAll" v-model="checkedProductsAll" >
                                                        <span class="-checkbox-primary"></span>
                                                    </label>
                                                    </div>
                                                    <div style="width: 8%;">Code</div>
                                                    <div style="width: 18%;">Description</div>
                                                    <div style="width: 6%;" class="-text-center">Stock</div>
                                                    <div style="width: 6%;" class="-text-left">Class</div>
                                                    <div style="width: 5%;" class="-text-left">Unit</div>
                                                    <div style="width: 7%;" class="-text-center">Min</div>
                                                    <div style="width: 7%;" class="-text-center">Max</div>
                                                    <div style="width: 9%;" class="-text-center">Net Price</div>
                                                    <div style="width: 12%;" class="-text-center">Default Price</div>
                                                    <div style="width: 11%;" class="-text-center">Promo Price</div>
                                                    <div style="width: 7%;" class="-text-center">Cost</div>
                                                </div>
                                                <div id="divBodyUpdate"> 
                                                    <div :class="(item.status == 'Inactive') ? '-inactive-product' : ''" style="height: 45px;" v-for="(item, updateIndex) in products" :key="updateIndex" v-show="item.display">
                                                        <div style="width: 4%;" class="div_ck">
                                                            <label class="checkbox-container">
                                                                <input type="checkbox" v-model="checkedProducts" :id="item.code" :value="item">
                                                                <span class="-checkbox-primary"></span>
                                                            </label>
                                                        </div>
                                                        <div style="width: 8%;" class="div_code">{{ item.code }}</div>
                                                        <div style="width: 18%;" class="nowrap-title div_desc">
                                                            <span :title="item.title_th" class="kanitfont">{{ item.title_th }}</span>
                                                        </div>
                                                        <div style="width: 6%;" class="-text-center div_stock">{{ item.stock }}</div>
                                                        <div style="width: 6%;" class="-text-left div_class">{{ item.class  }}</div>
                                                        <div style="width: 5%;" class="-text-left div_unit">{{ item.seu_code  }}</div>
                                                        <div v-if="(item.status == 'Inactive')" style="width: 7%; padding-top: 15px;" class="-text-center" >-</div>
                                                        <div v-else style="width: 7%; padding-top: 15px;" class="-text-center" >
                                                            <input style="width: -webkit-fill-available;" class="input_td" type="number" min="0" max="9999999"  v-model="item.min"  placeholder="Min">
                                                        </div>
                                                        <div v-if="(item.status == 'Inactive')" style="width: 7%; padding-top: 15px;" class="-text-center" >-</div>
                                                        <div v-else style="width: 7%; padding-top: 15px;" class="-text-center">
                                                            <input style="width: -webkit-fill-available;" class="input_td" type="number" min="0" max="9999999" v-model="item.max"  placeholder="Max">
                                                        </div>
                                                        <div v-if="(item.status == 'Inactive')" style="width: 9%; padding-top: 15px;" class="-text-center" >-</div>
                                                        <div v-else style="width: 9%;padding-top: 15px;" class="-text-center">
                                                            <input style="width: -webkit-fill-available;" class="input_td" type="number" min="0" max="9999999" v-model="item.netprice"  placeholder="Net Price">
                                                        </div>
                                                        <!-- <div style="width: 12%;" class="-text-right div_price" >{{ (item.price != '' ? parseFloat(item.price).toFixed(2): '')}}</div> -->
                                                        <!-- <div style="width: 11%;" class="-text-right div_price" >{{ (item.promo_price != '' && item.promo_price !== undefined ? parseFloat(item.promo_price).toFixed(2): 0)}}</div> -->
                                                        <div style="width: 12%;" class="-text-right div_price" >{{ (item.price != '' ? formatNumber(item.price, 2) : '')}}</div>
                                                        <div style="width: 11%;" class="-text-right div_price" >{{ (item.promo_price != '' && item.promo_price !== undefined ? formatNumber(item.promo_price, 2) : 0)}}</div>
                                                        <div style="width: 7%;" class="-text-right div_cost">{{ (item.cost_show != '' ? parseFloat(item.cost_show).toFixed(2): '')}}</div>
                                                    </div>
                                                </div>
                                                <!-- <div class="footer-table">number of product ({{products.length}})</div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
                <md-card-actions class="mktops-action-button">
                    <div style="width: 33%; color: red; font-style: italic; text-align: left; margin-left: 20px;">*Product code ที่ถูก Inactive</div>
                    <div style="width: 34%; font-style: italic; text-align: center;">number of product ({{products.length}})</div>
                    <div style="width: 33%;">
                        <md-button class="mktops-button-back-next" @click="nextStep('step-1')">back</md-button>
                        <md-button class="mktops-button-back-next md-primary" @click="nextStep('step-3')">next</md-button>
                    </div>
                </md-card-actions>
            </md-card>
            <md-dialog-alert 
                :md-active.sync="alertshow" 
                md-title="Alert!" 
                md-content="Please select products by uploading a .csv, <br/>  or adding by product code"/>

            <DialogAlertCondition ref="dialogAlertCondition" v-model="alertImport" :completeProduct="msgImport" :lostProduct="msgImportLost" @cilckOK="onCilckOKImport"></DialogAlertCondition>
            <DialogAlertCondition ref="dialogAlertCondition" v-model="showDialogAlert" :completeProduct="completeProduct" :lostProduct="alertProductLost" @cilckOK="onCilckOK"></DialogAlertCondition>

            <stepper></stepper>
        </div>

        <md-dialog-alert :md-active.sync="alertCondition" md-title="Alert!" md-content="Value max must be greater than value min" />
        <!-- <md-dialog-alert :md-active.sync="alertNetPrice" md-title="Alert!" md-content="All fields net price must be filled in." /> -->
        
        <!-- START DIALOG FILTER PRODUCT -->
        <md-dialog :md-active.sync="showDialogFilter" class="dialog-filter-product" :md-click-outside-to-close="false">
            <md-dialog-title>All Product</md-dialog-title>

            <div class="layout-dialog" style="display: flex;">
                <div class="md-layout-item md-large-size-30 md-medium-size-30">
                    <!-- <div class="md-layout-item md-large-size-25 md-medium-size-25"> -->
                    <div style="width: 100%;">
                        <div style="margin: 10px 5px 13px 5px;">
                            <multiselect v-model="selectedProoductGroup" id="group" label="title" track-by="code" placeholder="All Product Group" :open-direction="'bottom'" :options="optionsProoductGroup" :searchable="true" :max-height="180" :show-no-results="false" :custom-label="customLabelProoduct" :select-label="''" :deselect-label="''" :selected-label="''" :hide-selected="true" @select="setDataProoduct">
                                <template slot="singleLabel" slot-scope="{ option }">
                                    <div>
                                        <div class="-label">
                                            {{ option.code }} - {{ option.title }}
                                        </div>
                                        <div class="-delete" @mousedown.prevent.stop="clearAll(option.code, 'group')"><i class="material-icons">close</i></div>
                                    </div>
                                </template>
                            </multiselect>
                        </div>
                    </div>
                    <!-- <div class="md-layout-item md-large-size-25 md-medium-size-25"> -->
                    <div style="width: 100%;">
                        <div style="margin: 10px 5px 13px 5px;">
                            <multiselect v-model="selectedProoductSubGroup" id="subgroup" label="title" track-by="code" placeholder="All Sub Group" :open-direction="'bottom'" :options="optionsProoductSubGroup" :searchable="true" :max-height="180" :show-no-results="false" :custom-label="customLabelProoduct" :select-label="''" :deselect-label="''" :selected-label="''" :hide-selected="true" @select="setDataProoduct">
                                <template slot="singleLabel" slot-scope="{ option }">
                                    <div>
                                        <div class="-label">
                                            {{ option.code }} - {{ option.title }}
                                        </div>
                                        <div class="-delete" @mousedown.prevent.stop="clearAll(option.code, 'subgroup')"><i class="material-icons">close</i></div>
                                    </div>
                                </template>
                            </multiselect>
                        </div>
                    </div>
                    <!-- <div class="md-layout-item md-large-size-25 md-medium-size-25"> -->
                    <div style="width: 100%;">
                        <div style="margin: 10px 5px 13px 5px;">
                            <multiselect v-model="selectedProoductCG" id="cg" label="title" track-by="code" placeholder="All CG" :open-direction="'bottom'" :options="optionsProoductCG" :searchable="true" :max-height="180" :show-no-results="false" :custom-label="customLabelProoduct" :select-label="''" :deselect-label="''" :selected-label="''" :hide-selected="true" @select="setDataProoduct">
                                <template slot="singleLabel" slot-scope="{ option }">
                                    <div>
                                        <div class="-label">
                                            {{ option.code }} - {{ option.title }}
                                        </div>
                                        <div class="-delete" @mousedown.prevent.stop="clearAll(option.code, 'cg')"><i class="material-icons">close</i></div>
                                    </div>
                                </template>
                            </multiselect>
                        </div>
                    </div>
                    <!-- <div class="md-layout-item md-large-size-25 md-medium-size-25"> -->
                    <!-- <div style="width: 96%;">
                        <md-field class="md-search-box">
                            <i class="md-icon material-icons">search</i>
                            <md-input type="text" placeholder="Search by Code or Name.." v-model="searchFilterProductName"></md-input>
                        </md-field>
                    </div> -->
                    <div class="filter-table" style="width: 100%;">
                        <input type="text" v-model="searchFilterProductCode" placeholder="Search by product code....">
                    </div>

                    <div class="filter-table" style="width: 100%; margin-top: 10px;">
                        <input type="text" v-model="searchFilterProductName" placeholder="Search by product name....">
                    </div>

                    <div style="text-align: center; margin-top: 20px;">
                        <md-button class="md-raised md-primary filter-search" @click="searchProduct()">SEARCH</md-button>
                    </div>

                    <!-- <div v-show="(checkCondition == true)" class="-conditions">
                        <div class="title" style="width: 100%;">Check conditions</div>
                        <div style="width: 100%;">
                            <ul>
                                <li>Product ที่มีสถานะเป็น Inactive จะไม่นำมาแสดง</li>
                                <li>Product ที่มี Product Lift Cycle นอกจากที่กำหนดไว้ จะไม่นำมาแสดง</li>
                                <li>Product ที่ไม่มีการตั้งราคา A3 ไว้ จะไม่นำมาแสดง</li>
                            </ul>
                        </div>
                    </div> -->
                </div>

                <div class="md-layout-item md-large-size-70 md-medium-size-70 mkt-ops -main-font" style="padding-left: 25px;">
                    <div id="table-product-filter">
                        <div id="divHeadList">
                            <div style="width: 4%;">
                                <label class="-mkt-checkbox-container">
                                    <input type="checkbox" @click="selectAllProductFilter" v-model="checkedProductFilterAll">
                                    <span class="-mkt-checkbox"></span>
                                </label>
                            </div>
                            <div style="width: 10%;">Code</div>
                            <div style="width: 41%;">Description</div>
                            <div style="width: 7%;" class="-text-center">Stock</div>
                            <div style="width: 7%;" class="-text-center">Class</div>
                            <div style="width: 7%;">Unit</div>
                            <div style="width: 13%;" class="-text-right">Default Price</div>
                            <div style="width: 11%;" class="-text-right">Cost</div>
                        </div>
                        <div id="divBodyList">
                            <div v-show="(tbListProduct == null || tbListProduct.length == 0)" :class="'row-bg-gray'" style="display: block; text-align: center;">No data in table.</div>
                            <div :class="'row-bg-gray'" v-for="(item, rIndex) in tbListProduct" :key="rIndex">
                                <div style="width: 4%;">
                                    <label class="-mkt-checkbox-container">
                                        <input type="checkbox" v-model="checkedProductFilter" :id="item.code" :value="item.code" @click="selectProductFilter(item.code)">
                                        <span class="-mkt-checkbox"></span>
                                    </label>
                                </div>
                                <div style="width: 10%;">{{ item.code }}</div>
                                <div style="width: 41%;" class="nowrap-title -font-kanit">
                                    <span :title="item.title_th">{{ item.title_th }}</span>
                                </div>
                                <div style="width: 7%;" class="-text-center">{{ item.stock }}</div>
                                <!-- <div style="width: 7%;" class="-text-center">{{ item.class }}</div> -->
                                <div style="width: 7%;" class="-text-center">{{ item.productpmd_code }}</div>
                                <div style="width: 7%;">{{ item.seu_code }}</div>
                                <div style="width: 13%;" class="-text-right">{{ (item.price != '' ? formatNumber(item.price, 2) : '')}}</div>
                                <div style="width: 11%;" class="-text-right">{{ (item.cost_show != '' ? parseFloat(item.cost_show).toFixed(2): '')}}</div>
                            </div>
                        </div>
                        <div class="footer-table">number of lines in table ({{tbListProduct.length}})</div>
                    </div>
                </div>
            </div>

            <md-dialog-actions class="-action">
                <md-button class="md-primary -cancel" @click="onClickClose()">CLOSE</md-button>
                <md-button :class="(disableAddData && checkedProductFilter.length == 0) ? 'md-primary -save -disabled' : 'md-primary -save'" :disabled="disableAddData" @click="onclickAddProduct()">ADD TO TABLE</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-snackbar :md-position="position" :md-duration="isInfinity ? Infinity : duration" :md-active.sync="showSnackbar" md-persistent>
            <span>{{ dContent }}</span>
            <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
        </md-snackbar>
        <!-- END DIALOG FILTER PRODUCT -->

    </div>
</template>
<script>
import PromotionService from "@/services/promotion";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import promotionService from "@/services/promotion";
import {
    ASYNC_SEARCH
} from '@riophae/vue-treeselect';
import { constants } from 'crypto';
const simulateAsyncOperation = fn => {
    setTimeout(fn, 2000)
}

import DialogAlertCondition from "@/components/shared/dialog-alert-condition";

  var _ = require('lodash');
  var csv = require('csvtojson');
  export default {
    name: 'step2',
    created () {
        var self = this;
        _.forEach(self.products, function(value) {
            self.valueTree = _.union(self.valueTree, [value.code]);
        });
        
        // this.$store.dispatch('pmcreate/getGroups')
        //this.searchOnTable()
    },
    components: {
        Treeselect,
        'stepper': require('@/components/promotion/create/stepper').default,
        DialogAlertCondition
    },
    computed: {
        // groups(){
        //     return this.$store.getters['pmcreate/groups']
        // },
        // subgroups(){
        //     return this.$store.getters['pmcreate/subgroups']
        // },
        // cggroups(){
        //     return this.$store.getters['pmcreate/cggroups']
        // },
        // unitmaster(){
        //     return this.$store.getters['pmcreate/unitmaster']
        // },
        // probrowse(){
        //     return this.$store.getters['pmcreate/probrowse']
        // },
        loadData() {
            return this.$store.getters["pmmanage/loadData"];
        },
        products: {
            get() {
                return this.$store.state["pmcreate"].value.products;
            },
            set(value) {
                this.$store.commit("pmcreate/update", {
                field: "products",
                value
                });
            }
        },
        // messageClass () {
        //     return {
        //     'md-invalid': this.hasMessages
        //     }
        // },
    },
    watch: {
        products() {
            this.products = this.$store.state["pmcreate"].value.products;
        }
    },
    data: () => ({
        showSnackbar: false,
        position: "center",
        duration: 4000,
        isInfinity: true,
        dContent: "",
        // disableAddData: true,
        disableAddData: false,
        // checkedLengthProductFilter: [],
        checkedProductFilter: [],
        checkedProductFilterAll: false,
        selectedProoductGroup: [],
        optionsProoductGroup: [],
        selectedProoductSubGroup: [],
        optionsProoductSubGroup: [],
        selectedProoductCG: [],
        optionsProoductCG: [],
        searchFilterProductCode: '',
        searchFilterProductName: '',
        tbListProduct: [],
        showDialogFilter: false,
        showDialogAlert: false,
        completeProduct: "",
        alertProductLost: "",
        alertCondition: false,
        // alertNetPrice: false,
        showDialog: false,
        groupsMode: null,
        subgroupsMode: '',
        cggroupsMode: '',
        product_code: '',
        searched: [],
        selected: [],
        importProduct: [],
        unimportProduct: [],
        hasMessages: false,
        nextItem: 1,
        items: [],
        skip: 0,
        loading: false,
        keyword:'',
        alertshow : false,
        alertImport : false,
        msgImport : '',
        msgImportLost : '',
        search: '',
        valueConsistsOf: 'LEAF_PRIORITY',
        valueTree: [],
        vFilter: '',
        createDatasOld: [],
        checkDataDelete: [],
        dataTreeview: [],
        checkedProducts: [],
        createDatas: [],
        optionsTreeview: [],
        checkedProductsAll:false,
        input_tree:'',
        checkCondition: false,
    }),
    updated(){
    },
    beforeDestroy(){
    },
    mounted() {
        this.$store.commit("pmmanage/loadingPage", false);
    },
    methods: {
        onCilckOKImport() {
            this.alertImport = false;
        },
        onCilckOK() {
            this.showDialogAlert = false;
        },
        getAllProduct(datas) {
            promotionService.getAllProduct(datas).then(response => {
                    if (response) {
                        this.optionsProoductGroup = (response.data.product_group !== undefined) ? response.data.product_group.sort((a, b) => (a.code > b.code) ? 1 : -1) : [];
                        this.optionsProoductSubGroup = (response.data.product_subgroup !== undefined) ? response.data.product_subgroup.sort((a, b) => (a.code > b.code) ? 1 : -1) : [];
                        this.optionsProoductCG = (response.data.product_cg !== undefined) ? response.data.product_cg.sort((a, b) => (a.code > b.code) ? 1 : -1) : [];

                        if(datas !== undefined && datas.type == 'subgroup') {
                            this.selectedProoductGroup = response.data.product_group[0];
                        } else if(datas !== undefined && datas.type == 'cg') {
                            this.selectedProoductGroup = response.data.product_group[0];
                            this.selectedProoductSubGroup = response.data.product_subgroup[0];
                        }
                    }
                })
                .catch();
        },
        getAllProductSearch(datas) {
            this.$store.commit("pmmanage/loadingPage", true);

            let self = this;
            this.products.forEach(function (value, key) {
                self.checkedProductFilter.push(value.code);
            });

            promotionService.getAllProductSearch(datas).then(response => {
                    if (response) {
                        if(response.data.length > 0) {
                            this.tbListProduct = response.data.sort((a, b) => (a.code > b.code) ? 1 : -1);
                            this.checkCondition = false;
                        } else {
                            this.tbListProduct = [];
                            // this.checkCondition = true;
                        }
                        // this.tbListProduct = (response.data !== undefined) ? response.data.sort((a, b) => (a.code > b.code) ? 1 : -1) : [];
                    }
                    this.checkedProductFilterAll = false;
                    this.$store.commit("pmmanage/loadingPage", false);
                })
                .catch();
        },
        selectProductFilter(code) {
            if(this.checkedProductFilter.indexOf(code) == -1) {
                this.checkedProductFilter.push(code);
            } else {
                this.checkedProductFilter.splice(this.checkedProductFilter.indexOf(code), 1);
                let index = this.products.findIndex(item => item.code === code);
                this.products.splice(index, 1);
                this.valueTree.splice(index, 1);
            }
            
            // this.disableAddData = (this.checkedProductFilter.length > 0) ? false : true;
        },
        selectAllProductFilter() {
            this.checkedProductFilter = [];
            if (!this.checkedProductFilterAll) {
                for (let itemCode in this.tbListProduct) {
                    if(this.tbListProduct[itemCode].used === undefined || this.tbListProduct[itemCode].used == false) {
                        this.checkedProductFilter.push(this.tbListProduct[itemCode].code);
                    }
                }
                // this.disableAddData = (this.checkedProductFilter.length > 0) ? false : true;
            } else {
                // this.disableAddData = (this.checkedProductFilter.length > 0) ? false : true;
            }
        },
        clearAll(id, type) {
            if (type == 'group') {
                this.selectedProoductGroup = [];
                this.selectedProoductSubGroup = [];
                this.selectedProoductCG = [];
                this.getAllProduct();
            } else if (type == 'subgroup') {
                let datas = { type: 'group', code:  this.selectedProoductGroup.code};
                this.selectedProoductSubGroup = [];
                this.selectedProoductCG = [];
                this.getAllProduct(datas);
            } else if (type == 'cg') {
                let datas = { type: 'subgroup', code:  this.selectedProoductSubGroup.code};
                this.selectedProoductCG = [];
                this.getAllProduct(datas);
            }
        },
        searchProduct() {
            let v_group = this.selectedProoductGroup.code;
            let v_subgroup = this.selectedProoductSubGroup.code;
            let v_cg = this.selectedProoductCG.code;
            if((v_group == "" || v_group == null) && (v_subgroup == "" || v_subgroup == null) && (v_cg == "" || v_cg == null) && 
            (this.searchFilterProductCode == "" || this.searchFilterProductCode ==null) && (this.searchFilterProductName == "" || this.searchFilterProductName == null)) {
                this.showSnackbar = true;
                this.dContent = "Please select or fill in the input you want to search."
            } else {
                let datas = { group: v_group, subgroup: v_subgroup, cg: v_cg, code: this.searchFilterProductCode, name: this.searchFilterProductName };
                this.getAllProductSearch(datas);
            }
        },
        setDataProoduct(selectedOption, id) {
            let datas = { type: id, code: selectedOption.code };
            this.getAllProduct(datas);
        },
        customLabelProoduct({
            code,
            title
        }) {
            return `${code} - ${title}`
        },
        onclickAddProduct() {
            for(let i = 0; i < this.tbListProduct.length; i++) {
                let index = this.products.findIndex(item => item.code === this.tbListProduct[i].code);
                if(index < 0) {
                    // this.products.push(this.tbListProduct[i])
                    if(this.checkedProductFilter.indexOf(this.tbListProduct[i].code) > -1) {
                        this.valueTree = _.union(this.valueTree, [this.tbListProduct[i].code]);
                        this.openOnSelectTreeview(this.tbListProduct[i])
                    }
                }
            }
            this.showDialogFilter = false;
            // this.disableAddData = true;

            this.selectedProoductGroup = [];
            this.selectedProoductSubGroup = [];
            this.selectedProoductCG = [];
            this.searchFilterProductCode = "";
            this.searchFilterProductName = "";
            this.tbListProduct = [];
            this.checkedProductFilterAll = false;
            this.checkedProductFilter = [];
            this.checkCondition = false;
        },
        onClickClose() {
            this.selectedProoductGroup = [];
            this.selectedProoductSubGroup = [];
            this.selectedProoductCG = [];
            this.searchFilterProductCode = "";
            this.searchFilterProductName = "";
            this.tbListProduct = [];
            this.showDialogFilter = false;
            this.checkedProductFilterAll = false;
            this.checkedProductFilter = [];
            this.checkCondition = false;
        },
        onClickDialogFilter() {
            this.getAllProduct();
            this.showDialogFilter = true;
        },
        formatNumber(value, dicimal) {
            if (isNaN(parseFloat(value))) {
                let val = 0;
                return val.toFixed(dicimal);
                // return value;
            } else {
                if (value % 1 == 0) {
                    return parseFloat(value).toLocaleString(undefined, {
                        minimumFractionDigits: dicimal,
                        maximumFractionDigits: dicimal
                    });
                } else {
                    let parts = value.toString().split(".");
                    let num = (parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                    let digit = parts[1].slice(0, 3);
                    digit = (digit.length < 2) ? digit + "0" : digit;
                    let rs = num + "." + digit;
                    let comma = parseFloat(rs.replace(',', ''));
                    // return Math.round(parseFloat(comma) * 100) / 100;
                    return parseFloat(Math.round(parseFloat(comma) * 100) / 100).toLocaleString(undefined, {
                        minimumFractionDigits: dicimal,
                        maximumFractionDigits: dicimal
                    });
                }
            }
        },
        searchOnTable () {
            var self = this;
			if(self.search != ''){
				_.forEach(this.products, function(o) {
					let keyword = self.search.toLowerCase();
					let code = o.code.toLowerCase();
					let desc = o.title_th.toLowerCase();
					let c1 = code.search(keyword);
					let c2 = desc.search(keyword);
					if((c1 >= 0) || (c2 >= 0)){
						o.display = 'show'
					}else{
						o.display = ''
					}
				});
			}else{
				_.forEach(this.products, function(o) {
					o.display = 'show'
				});
			}
  
        },
        
        trigger (){
            this.$refs.fileInput.click()
        },
        resetfile() {
            const input = this.$refs.fileInput
            input.type = 'text'
            input.type = 'file'
        },
        processFile() {
            this.$store.commit("pmmanage/loadingPage", true);
            var files =  this.$refs.fileInput.files
            var reader = new FileReader()
            var rows = []
            var codeStr = ""
            var arrProduct = {}
            var ck = false
            let chkMinMax = true
            if(files[0]){
                reader.onloadend = function () {
                    var csvStr = reader.result
                    csv({flatKeys:true})
                    .fromString(csvStr)
                    .on('json',(json)=>{
                        var code = json['code'].trim()
                        if(code.charAt(0) === "'"){
                            code = code.substr(1);
                        }
                        let price = '', min = '', max = '';
                        
                        if(json['netprice'] !== undefined && json['netprice'].trim() !== ''){
                            price = parseFloat(json['netprice'].replace(',', ''));
                        }
                        if(json['min'] !== undefined && json['min'].trim() !== ''){
                            min = parseFloat(json['min'].replace(',', ''))
                        }
                        if(json['max'] !== undefined && json['max'].trim() !== ''){
                            max = parseFloat(json['max'].replace(',', ''))
                        }
                        if(max !== '' && min !== '' && min > max){
                            chkMinMax = false
                        }
                        arrProduct[code] = {
                            netprice: price,
                            min: min,
                            max: max
                        };
                        
                        //arrProduct.push(json);
                        //codeStr = (codeStr)?codeStr+","+code:code
                        //rows[code] = json['netprice']
                    }).on('done',()=>{
                        ck = true
                    })
                }
                reader.readAsText(files[0]);
                setTimeout(() => {
                    this.product_code = ""
                    if(Object.keys(arrProduct).length > 0 && ck && chkMinMax){
                        let import_product_code = Object.keys(arrProduct)
                        var self = this;
                        simulateAsyncOperation(() => {
                            PromotionService.ProductImport({data: arrProduct}).then(response => {
                            //PromotionService.ProductTree(codeStr).then(response => {
                                    self.optionsTreeview =  []
                                    let import_product_comp = [];
                                    if(response.data.length > 0){
                                        response.data.forEach(function (value, key) {
                                            import_product_comp.push(value.code)
                                            self.valueTree = _.union(self.valueTree, [value.code]);
                                            self.openOnSelectTreeview(value)
                                        })
                                    }
                                    let a = new Set(import_product_comp)
                                    let b = new Set(import_product_code)
                                    let union = new Set([...a, ...b])
                                    let diff = new Set([...b].filter(x => !a.has(x)));
                                    // this.msgImport = 'total '+response.data.length+' item.'
                                    this.msgImport = response.data.length
                                    this.msgImportLost = [...diff].join(', ');
                                    this.$store.commit("pmmanage/loadingPage", false);
                                    this.alertImport = true
                                    
                                    self.optionsTreeview = response.data
                                    self.resetfile()
                                
                            }).catch();
                        })
                    }else if(Object.keys(arrProduct).length > 0 && ck && chkMinMax === false){
                        this.msgImport = 'Max cannot be less than min.'
                        this.msgImportLost = '';
                        this.$store.commit("pmmanage/loadingPage", false);
                        this.alertImport = true
                        this.resetfile()
                    }
                }, 500)
            }

        },
        nextStep(step){
            if(step == 'step-3'){
                if(this.products.length > 0 && step){
                    let self = this;
                    // let checknetprice = 0;
                    for(let i = 0; i < this.products.length; i++) {
                        if(parseFloat(this.products[i].min) > parseFloat(this.products[i].max)) {
                            self.alertCondition = true;
                            return;
                        }
                        if( ! isNaN(parseFloat(this.products[i].min))){
                            this.products[i].min = parseFloat(this.products[i].min);
                        }
                        if( ! isNaN(parseFloat(this.products[i].max))){
                            this.products[i].max = parseFloat(this.products[i].max);
                        }

                        // if(parseFloat(this.products[i].netprice) > 0) {
                        //     checknetprice++;
                        // }
                    }

                    // if(checknetprice > 0 && checknetprice != this.products.length) {
                    //     self.alertNetPrice = true;
                    //     return;
                    // }

                    // let flag = false;
                    // if(checknetprice > 0 && checknetprice == this.products.length) {
                    //     flag = true;
                    // }
                    // this.$store.commit('pmcreate/setNetPriceFlag', flag);
                    this.$store.commit('pmcreate/setStep', step);
                }else{
                    this.alertshow = true
                }
            }else{
                this.$store.commit('pmcreate/setStep', step)
            }
            // this.$store.commit('pmcreate/setStep', step)
        },
        toLower(text){
            return text.toString().toLowerCase()
        },

        addProducts(){
         
        },
        clearProducts(){
            this.product_code = ''
        },
        loadOptions({
            action,
            searchQuery,
            callback
        }) {
            let self = this;
            let text = '';
            let type = 'input';
            this.input_tree =searchQuery;
            if (searchQuery.split(' ').length <= 1) {
                text = searchQuery;
            } else {
                let splitText = searchQuery.split(' ');
                if (splitText.length < 1000) {
                    let texts = '';
                    splitText.forEach(function (value, key) {
                        texts += value + ',';
                    });
                    text = texts.substring(0, texts.length - 1);
                    type = 'paste';
                } else {
                    this.dContent = "Data input text have Code more than 1000 Code.";
                    this.showSnackbar = true;
                    return false;
                }
            }
            let input_search = self.$refs.productTxt;
            let real_input = input_search.$el.querySelector('.vue-treeselect__input')
            if (action === ASYNC_SEARCH && text.length >= 4 && text.length <= 8) {
                simulateAsyncOperation(() => {
                    PromotionService.ProductTree(text).then(response => {
                        if(response.data == '' || response == '' || response == null) {
                            // alert when item incorrect
                            if(response.message !== undefined){
                                self.alertProductLost = "";
                                let number_msg = response.message.length;
                                response.message.forEach(function (value, key) {
                                    self.alertProductLost += (key == (number_msg - 1)) ? value : value + ", ";
                                });
                                if(response.message.length > 0) {
                                    self.showDialogAlert = true;
                                }
                            }
                            self.optionsTreeview =  []
                            callback(null, self.optionsTreeview)
                        } else {
                            if(response.data.id ==  text || (response.data.children !== undefined && response.data.children[0].code ==  text) 
                                    || (response.data.children === undefined && response.data.code == text)){
                                        self.optionsTreeview =  []
                                self.optionsTreeview.push(response.data)

                                self.completeProduct = response.data.length;
                                self.alertProductLost = "";
                                let length = response.message.length - 1;
                                response.message.forEach(function (value, key) {
                                    self.alertProductLost += (key == length) ? value : value + ", ";
                                });
                                if(response.message.length > 0) {
                                    self.showDialogAlert = true;
                                }
                                
                                callback(null, self.optionsTreeview)
                            }
                            real_input.value = '' // clear input search product
                        }
                    }).catch();
                })
            }

            var arr_id = text.split(/,/g);
            if(arr_id.length > 1){
                simulateAsyncOperation(() => {
                    PromotionService.ProductTree(text).then(response => {
                        if(response.message.length > 0) {
                            self.alertProductLost = "";
                            let length = response.message.length - 1;
                            response.message.forEach(function (value, key) {
                                self.alertProductLost += (key == length) ? value : value + ", ";
                            });
                            self.showDialogAlert = true;
                        }

                        if(response.data.length > 0){
                            self.optionsTreeview =  []
                            response.data.forEach(function (value, key) {
                                self.valueTree = _.union(self.valueTree, [value.code]);
                                self.openOnSelectTreeview(value)
                            })
                            self.optionsTreeview = response.data

                            self.completeProduct = response.data.length;
                            callback(null, self.optionsTreeview)
                            
                            real_input.value = '' // clear input search product
                        } else {
                            self.optionsTreeview =  []
                            callback(null, self.optionsTreeview)
                        }
                    }).catch();
                })
            }else{

            }
            
        },
        openOnSelectTreeview(node) {
            let self = this;
            if (node.children) {
                node.children.forEach(function (value, key) {
                    if (value.children) {
                        self.openOnSelectTreeview(value);
                    } else { //Check ตัวแม่จาก level รองสุดท้าย
                        value.display = 'show';
                        value.class = value.productpmd_code;
                        value.seu_code = value.selling_um_title;
                        delete value.productpmd_code;
                        delete value.selling_um_title;
                        self.products = _.unionBy(self.products, [value], 'code');
                    }
                });
            } else { //Check last level
                node.display = 'show';
                node.class = node.productpmd_code;
                node.seu_code = node.selling_um_title;
                delete node.productpmd_code;
                delete node.selling_um_title;
                self.products = _.unionBy(self.products, [node], 'code');
                let index_product = _.findIndex(self.products, {code:node.code})
                if(index_product >= 0){
                   self.products[index_product].netprice = (node.netprice)? parseFloat(node.netprice) : '';
                   self.products[index_product].max = (node.max)? parseFloat(node.max) : '';
                   self.products[index_product].min = (node.min)? parseFloat(node.min) : '';
                }
            }
        },
        onDeSelectTreeview(node) {
            let self = this;
            if (node.children) {
                node.children.forEach(function (value, key) {
                    if (value.children) {
                        self.onDeSelectTreeview(value);
                    } else { //Check ตัวแม่จาก level รองสุดท้าย
                        let index = self.products
                            .map(function (e) {
                                return e.code;
                            })
                            .indexOf(value.code);
                            if(index > -1) {
                                self.products.splice(index, 1);
                            }
                    }
                });
            } else { //Check last level
                // console.log("--ELSE--");
                let index = self.products
                    .map(function (e) {
                        return e.code;
                    })
                    .indexOf(node.code);
                self.products.splice(index, 1);
            }
   
        },
        setDataArrayTree(check, value) {
        },
        onOpenTreeview() {
        },
        deleteProduct() {
            var self = this;
            var re_diff = _.difference(this.products,this.checkedProducts);
            _.forEach(self.checkedProducts, function(value) {
                self.valueTree.splice(self.valueTree.indexOf(value.code), 1);

            });
            this.products=re_diff;
            this.checkedProducts = [];
            this.checkedProductsAll = false
        },
        selectAll() {
            var self = this;
            if(this.checkedProductsAll == false){
                if(self.search == ''){
                    var re_diff = _.xor(this.products, []);
                    this.checkedProducts=re_diff
                }else{
                    var temp_filter = _.filter(this.products, {'display': 'show'});
                    this.checkedProducts = temp_filter
                }
            }else{
                this.checkedProducts=[]
            }
        },
        export_format() {
            let template = [
                {
                    code: "'900282",
                    min: 10,
                    max: 99999,
                    netprice: 200
                },{
                    code: "'011116",
                    min: 10,
                    max: 99999,
                    netprice: 500
                }
            ];
            let json_template = template;
            if (json_template.length > 0) {
                this.JSONToCSVConvertor(json_template, "Template_import_product", true);
            }
        },
        JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
            var arrData =
                typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
            var CSV = "";
            if (ShowLabel) {
                var row = "";
                for (var index in arrData[0]) {
                    row += index + ",";
                }

                row = row.slice(0, -1);
                CSV += row + "\r\n";
            }

            for (var i = 0; i < arrData.length; i++) {
                let row = "";
                for (let index in arrData[i]) {
                    if (index != "netprice") {
                        row += arrData[i][index] + ",";
                    } else {
                        row += arrData[i][index];
                    }
                }

                row.slice(0, row.length - 1);
                CSV += row + "\r\n";
            }

            if (CSV == "") {
                alert("Invalid data");
                return;
            }

            var fileName = ReportTitle;
            var uri = "data:text/csv;charset=utf-8," + encodeURIComponent(CSV);
            var link = document.createElement("a");
            link.href = uri;
            link.style = "visibility:hidden";
            link.download = fileName + ".csv";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    },
  }
</script>

<style lang="scss">
#layout-default > div.mkt-main-content > div > div > div.md-gutter.mktops-stepper > div.md-card.main-content.md-theme-default > div.data-input-step {
    height: calc(100vh - 190px);
}
#layout-default > div.mkt-main-content > div > div > div.md-gutter.mktops-stepper > div.md-card.main-content.md-theme-default > div.md-card-actions.mktops-action-button.md-alignment-right {
    padding-bottom: 25px;
    padding-right: 20px;
}
#layout-default > div.mkt-main-content > div > div > div.md-gutter.mktops-stepper > div.md-card.main-content.md-theme-default > div.data-input-step.md-layout > div > div > div > div > div.md-layout-item.md-size-40 > div > button.md-input-action{
    top: unset;
}
#divBodyUpdate > div > div > input[type="number"].input_td::-webkit-input-placeholder {
    font-size: 18px;
    font-family: 'Roboto';
    text-align: center;
}
 .vue-treeselect__multi-value-item-container {
    display: none;
}

.vue-treeselect__limit-tip-text {
    display: none;
}
.md-layout2 {
    padding-left: 30px;
}


.div_ck{
    width: 5%; padding-left: 0px; padding-top: 15px;
}
.div_code{
    width: 8%;padding-top: 15px;
}
.div_desc{
    width: 26%;padding-top: 15px;
}
.div_stock{
    width: 8%;padding-top: 15px;
}
.div_class{
    width: 6%;padding-top: 15px;
}
.div_unit{
    width: 6%;padding-top: 15px;
}
.div_min{
    width: 7%;padding-top: 13px;
}

.div_netprice{
    width: 9%;padding-top: 13px;
}
.div_cost{
    width: 8%;padding-top: 15px;
}
.div_price{
    width: 6%;padding-top: 15px;
}

#table-update-scroll-step2 {

        /* The checkbox-container */
        .checkbox-container {
            display: block;
            position: relative;
            padding-left: 35px;
            margin-bottom: 12px;
            cursor: pointer;
            font-size: 22px;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }

        /* Hide the browser's default checkbox */
        .checkbox-container input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;
        }

        /* Create a custom checkbox */
        .-checkbox-primary {
            position: absolute;
            top: 0;
            left: 0;
            height: 20px;
            width: 20px;
            background-color: #fff;
            border: 2px solid #A8A8A8;
            border-radius: 4px;
        }

        /* On mouse-over, add a grey background color */
        .checkbox-container:hover input~.-checkbox-primary {
            background-color: #ccc;
        }

        /* When the checkbox is checked, add a blue background */
        .checkbox-container input:checked~.-checkbox-primary {
            background-color: #3e51b5;
            border-color: #3e51b5;
        }

        /* Create the -checkbox-primary/indicator (hidden when not checked) */
        .-checkbox-primary:after {
            content: "";
            position: absolute;
            display: none;
        }

        /* Show the -checkbox-primary when checked */
        .checkbox-container input:checked~.-checkbox-primary:after {
            display: block;
        }

        /* Style the -checkbox-primary/indicator */
        .checkbox-container .-checkbox-primary:after {
            left: 6px;
            top: 1px;
            width: 5px;
            height: 13px;
            border: solid white;
            border-width: 0 2px 2px 0;
            -webkit-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: rotate(45deg);
        }

        #divHeadUpdate {
            width: 98.9%;
            display: -webkit-inline-box;
            font-size: 13px;
            font-weight: bold;
            margin-top: 15px;
            margin-bottom: 10px;
            color: #8a8a8a;

            div {
                // border: 1px solid pink;
                padding-left: 5px;
                padding-right: 5px;

                &.-text-right {
                    text-align: right;

                    &.-usage {
                        padding-right: 13px;
                    }
                }

                &.-text-center {
                    text-align: center;
                }

                .md-checkbox {
                    margin: 0;
                    padding: 0;
                }
            }
        }

        #divBodyUpdate {
            width: 100%;
            height: calc(80vmin - 270px);
            //   height: calc(100vmin - 440px);
            display: block;
            overflow-y: scroll;
            font-size: 13px;
            
            >div {
                width: 100%;
                display: -webkit-inline-box;
                padding-top: 5px;
                padding-bottom: 5px;

                div {
                    // border: 1px solid pink;
                    padding-left: 5px;
                    padding-right: 5px;

                    &.-text-right {
                        text-align: right;
                    }

                    &.-text-center {
                        text-align: center;
                    }

                    &.nowrap-title {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .md-checkbox {
                        margin: 0;
                        padding: 0;
                    }
                    input{
                        border: 0;
                        outline: 0;
                        background: transparent;
                        border-bottom: 1px solid black;
                        text-align: right;
                    }
                    input::first-line{
                        font-size : 13px;
                    }
                    
                }
            }

            .-inactive-product,
            .-inactive-product input {
                // background-color: #ffd6d6;
                // color: #A8A8A8;
                color: red;
                font-style: italic;
            }

            &::-webkit-scrollbar {
                height: 7px;
                width: 8px;
            }
        }

        .footer-table {
            // border: 1px solid pink;
            display: block;
            text-align: center;
            margin-top: 15px;
            width: 99.6%;
            font-size: 14px;
            font-style: italic;
        }
    }
    

.dialog-filter-product {
    &.md-dialog {
        max-height: unset;
    }

    width: 90%;
    max-width: 90% !important;
    height: 80%;
    z-index: 18 !important;
    transform: unset !important;
    top: 9% !important;
    left: 5% !important;

    .md-dialog-title.md-title {
        font-size: 18px;
        margin-bottom: 5px;
        padding: 24px 25px 0;
    }

    .layout-dialog {
        padding: 10px 25px 5px 25px;
        font-family: kanit;
        color: #727272;

        ::placeholder {
            color: #BDBDBD;
            opacity: 1;
            font-size: 14px;
            font-family: lato;
        }
    }

    .-conditions {
        margin-top: 30px;
        margin-left: 10px;
        display: block;
        color: red;
        // position: absolute;
        bottom: 55px;
        left: 30px;

        .title {
            font-weight: bold;
        }

        ul {
            margin: 10px;
            padding-left: 10px;
        }

        ul, li {
            font-family: kanit;
            width: 100%;
        }
    }

    .-action {
        padding: 8px 20px 10px 24px;
        bottom: 0px;
        margin-right: auto;
        margin-left: auto;
        width: 100%;
        justify-content: flex-end;
        position: absolute;

        .-cancel .md-button-content {
            color: #727272;
        }

        .-save {
            color: #3f51b5 !important;

            &.-disabled {
                color: #b6b6b6 !important;
            }
        }

        .-red {
            color: #F44336 !important;
        }

        .-green {
            color: #64a064 !important;
        }
    }

    .multiselect {
        font-weight: 300;

        .z-index-top {
            z-index: 10;
        }

        margin: 5px 0px;

        .multiselect__single,
        .multiselect__input {
            font-size: 14px;

            div {
                display: flex;
                width: 100%;

                .-delete {
                    width: 5%;
                    margin: 0px 5px;

                    .material-icons {
                        font-size: 18px;
                        margin-top: 1px;
                        cursor: pointer;
                        color: gray;
                    }
                }
            }
        }

        .multiselect__tags {
            padding: 8px 30px 0 8px;

            input {
                font-family: lato;
                font-weight: 300;
            }

            .multiselect__placeholder {
                margin: 0px;
            }

            ::placeholder {
                color: #BDBDBD;
                opacity: 1;
            }
        }

        .multiselect__content-wrapper {
            font-size: 14px;
            z-index: 10;
        }

        .multiselect__option {
            min-height: 34px;
            padding: 12px 12px 0px 12px;
        }

        ::-webkit-scrollbar {
            width: 8px;
            height: 8px;
        }
    }

    // .md-search-box {
    //     // margin: 10px 10px 10px 0px;
    //     margin: 10px 5px;
    //     padding-top: unset;
    //     // width: 355px;
    //     border-radius: 3px;
    //     min-height: 40px;
    //     box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 rgba(0, 0, 0, 0),
    //         0 1px 1px -2px rgba(0, 0, 0, 0);

    //     .md-icon.material-icons {
    //         margin-left: 15px;
    //         margin-top: 9px;
    //         color: #000000;
    //         opacity: 0.54;
    //     }

    //     .md-input {
    //         height: 36px;
    //         margin-top: 2px;
    //         margin-left: 10px !important;
    //         margin-right: 5px;
    //         font-size: 14px;
    //         font-weight: 300;
    //         font-family: kanit;
    //         color: #adadad;

    //         white-space: nowrap;
    //         overflow: hidden;
    //         text-overflow: ellipsis;
    //     }

    //     &.md-field>.md-icon:after,
    //     &.md-field:after,
    //     &.md-field:before {
    //         content: none;
    //     }
    // }

    .filter-table {
        text-align: right;

        input {
            width: 97%;
            margin: 2px 5px;
            padding-left: 8px;
            padding-right: 13.8px;
            height: 40px;
            border: 1px solid #ddd;
            border-radius: 5px;
            background: #fff;
            font-size: 14px;
            font-weight: 300;
            font-family: kanit;
        }

        ::placeholder {
            font-size: 14px;
            font-weight: 300;
            font-family: kanit;
            color: #adadad;
        }
    }

    .filter-search {
        margin: 0px;
        width: 120px;
        height: 35px;
        // background-color: rgb(239, 239, 239);
        // color: #727272;
        color: #FFFFFF;
        background-color: #3F51B5;
        border-radius: 3px;
        box-shadow: unset;
    }

    #table-product-filter {
        #divHeadList {
            width: 99.4%;
            display: -webkit-inline-box;
            font-size: 13px;
            font-weight: bold;
            margin-top: 10px;
            margin-bottom: 10px;

            div {
                // border: 1px solid pink;
                padding-left: 5px;
                padding-right: 5px;
                // color: #414141;

                &.-text-right {
                    text-align: right;
                }

                &.-text-center {
                    text-align: center;
                }
            }
        }

        #divBodyList {
            width: 100%;
            height: calc(90vmin - 240px);
            display: block;
            overflow-y: scroll;
            // font-size: 13px;
            // font-weight: 300;

            >div {
                width: 100%;
                height: 35px;
                display: -webkit-inline-box;
                padding-top: 5px;
                padding-bottom: 5px;

                div {
                    // border: 1px solid pink;
                    padding-left: 5px;
                    padding-right: 5px;
                    // color: #414141;

                    &.-text-right {
                        text-align: right;
                    }

                    &.-text-center {
                        text-align: center;
                    }

                    &.nowrap-title {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    &.-font-kanit {
                        font-size: 14px;
                        font-family: kanit;
                    }
                }
            }

            &::-webkit-scrollbar {
                height: 7px;
                width: 5px;
            }
        }

        .footer-table {
            // border: 1px solid pink;
            display: block;
            text-align: center;
            margin-top: 8px;
            width: 99.6%;
            font-size: 14px;
            font-style: italic;
        }
    }
}
</style>